import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
const includes = ['6 professional modules', '5 professional bonuses', 'Battery & BMS diagnostics', 'Motor & inverter troubleshooting', 'Charging system diagnostics', 'Fault-finding workflows', 'Professional diagnostic references'];
export function PricingCard() {
  return <section id="offer" className="scroll-mt-2 bg-ev-black px-4 py-4 text-white" data-id="element-123" data-mp="2es6ydbixjllf">
      <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="29uf9yrhhuhlz">
        <p className="mb-1.5 text-center font-cond text-lg tracking-[0.18em] text-ev-neon sm:text-xl" data-id="element-125" data-mp="2535jxps19c9k">
          SPECIAL LAUNCH OFFER
        </p>
        <div className="rounded-xl border-2 border-ev-green bg-ev-panel p-3.5 text-center sm:p-5" data-id="element-126" data-mp="210sg56wujoff">
          <p className="font-cond text-2xl tracking-wide text-ev-green sm:text-3xl" data-id="element-127" data-mp="2xk9mf7xwi45p">
            ⚡ EV &amp; HYBRID DIAGNOSTIC PRO™
          </p>
          <h2 className="mb-2 font-display text-[19px] leading-tight text-white sm:text-[26px]" data-id="element-128" data-mp="2sqx054gp29g4">
            The Complete Visual Troubleshooting System for EV &amp; Hybrid Technicians
          </h2>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mb-2 block" aria-label="Get instant access" data-id="element-129" data-mp="2suixjvc9bt6k">
            <img src={PRODUCT_IMG} alt="EV &amp; Hybrid Diagnostic Pro complete 6-in-1 system box set" className="mx-auto w-full max-w-[230px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02] sm:max-w-[300px]" data-id="element-130" data-mp="2jtukb2uotwuq" />
          </a>

          <p className="mb-1.5 font-cond text-xl tracking-wide text-white sm:text-2xl" data-id="element-131" data-mp="2eu888wqlimni">
            Complete 6-in-1 System
          </p>
          <ul className="mx-auto mb-3 grid max-w-xl grid-cols-1 gap-1 text-left sm:grid-cols-2" data-id="element-132" data-mp="84tjhkjdobex">
            {includes.map(item => <li key={item} className="flex items-start gap-1.5 text-[13px] font-semibold leading-snug text-ev-steel sm:text-[14px]" data-id="element-133" data-mp="bm7vgkd2qgvh">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-ev-green" data-id="element-134" data-mp="6p7kbv1danxi" />
                {item}
              </li>)}
          </ul>

          <p className="mb-2 font-cond text-2xl leading-none tracking-wide text-ev-neon sm:text-4xl" data-id="element-135" data-mp="3tt5mnmq1sr1k">
            🔥 GET EV &amp; HYBRID DIAGNOSTIC PRO™ TODAY — $26.90
          </p>

          <CTAButton href={CHECKOUT_URL} external className="mx-auto max-w-md" subLabel="Immediate Digital Access" data-id="element-136" data-mp="penpivnzz4k9">
            ⚡ GET INSTANT ACCESS
          </CTAButton>

          <p className="mt-2 flex items-center justify-center gap-1 text-[11px] font-bold uppercase tracking-wide text-ev-steel sm:text-xs" data-id="element-137" data-mp="gl2arcbu1nau">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-ev-green" data-id="element-138" data-mp="18cqjlovejrox" />
            7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}